import * as yup from "yup";
import { yupHelper } from "lib/helpers";

import errorMessage from "./errorMessage";

const { postalCodeRegex, provinceCodeRegex, phoneNumberRegex } = yupHelper;

const firstNameSchema = yup.object().shape({
  firstName: yup.string().required(errorMessage.firstName).nullable(),
});

const lastNameSchema = yup.object().shape({
  lastName: yup.string().required(errorMessage.lastName).nullable(),
});

const { emailRegex, handleBrandRegex } = yupHelper;
const emailSchema = yup.object({
  email: yup
    .string()
    .required(errorMessage.email.requiredMessage)
    .matches(emailRegex, errorMessage.email.matches)
    .nullable(),
});

const phoneNumberSchema = yup.object().shape({
  phoneNumber: yup
    .string()
    .required(errorMessage.phoneNumber)
    .matches(phoneNumberRegex, errorMessage.positive)
    .min(7, errorMessage.minPhoneNumber)
    .max(15, errorMessage.maxPhoneNumber)
    .nullable(),
});

const citySchema = yup.object().shape({
  city: yup.string().required(errorMessage.city).nullable(),
});

const countrySchema = yup.object().shape({
  country: yup.string().required(errorMessage.country).nullable(),
});

const postalCodeSchema = (schema) => {
  const { min = 2 } = schema || {};
  const minPostalCode = errorMessage.minPostalCode.replace(2, min);
  return yup.object().shape({
    postalCode: yup
      .string()
      .required(errorMessage.postalCode)
      .matches(postalCodeRegex, errorMessage.alphanumeric)
      .min(min, minPostalCode)
      .max(32, errorMessage.maxPostalCode)
      .nullable(),
  });
};

const provinceCodeSchema = yup.object().shape({
  provinceCode: yup
    .string()
    .required(errorMessage.provinceCode)
    .matches(provinceCodeRegex, errorMessage.enterValidProvinceCode)
    .nullable(),
});

const streetAddressSchema = yup.object().shape({
  streetAddress: yup.string().required(errorMessage.streetAddress).nullable(),
});
const brandNameSchema = yup.object().shape({
  brandName: yup.string().required(errorMessage.brandName).nullable(),
});

const brandHandleSchema = yup.object().shape({
  brandHandle: yup
    .string()
    .required(errorMessage.slug)
    .matches(handleBrandRegex, errorMessage.slugValidation)
    .nullable(),
});

export {
  brandHandleSchema,
  brandNameSchema,
  citySchema,
  countrySchema,
  emailSchema,
  firstNameSchema,
  lastNameSchema,
  phoneNumberSchema,
  postalCodeSchema,
  provinceCodeSchema,
  streetAddressSchema,
};
